import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabItem } from '../tab.utils';
import { TabComponent } from '../tab/tab.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { NkChanges } from '@nk/utils-lib';

@Component({
  selector: 'nk-tab-menu',
  imports: [CommonModule, TabComponent, BsDropdownModule, TranslateModule],
  templateUrl: './tab-menu.component.html',
  styleUrls: ['./tab-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabMenuComponent<T> implements OnChanges {
  @Input() public tabs: TabItem<T>[] | undefined;
  @Output() public tabClicked = new EventEmitter<number>();

  public currentTabItem = signal<TabItem<T> | undefined>(undefined);

  public ngOnChanges(changes: NkChanges<TabMenuComponent<T>>): void {
    const tabs = changes.tabs?.currentValue;
    if (typeof tabs !== 'undefined') {
      this.currentTabItem.set(tabs.find((i) => i.active));
    }
  }

  public onTabClicked(tabIndex: number): void {
    this.tabClicked.emit(tabIndex);
  }
}
